////Users/bobbygilbert/Documents/GitHub/TPCTrust-platform/app/[locale]/(routes)/crm/leads/table-data/schema.tsx
// app/[locale]/(routes)/crm/leads/table-data/schema.tsx

import { z } from "zod";

export const leadSchema = z.object({
  id: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  firstName: z.string().optional().nullable(),
  lastName: z.string().max(255).optional().nullable(),
  status: z.string().optional().nullable(), // Add this line for the status field
});

export type Lead = z.infer<typeof leadSchema>;